<div class="mobile-top">
    <img src="{{logoInline}}">
</div>
<div class="mobile-body">

</div>
<div class="mobile-footer">
    <div class="mobile-menu-username">
        <span class="item-menu">{{userName}}</span>
    </div>
    <button id="mobile-logout" (click)="logout()">
        <i [class]="iconClass.LOG_OUT + ' menu-icon'"></i>
        <span class="item-menu text-menu" [translate]="'menu.logout'"></span>
    </button>
</div>